// Menú fijo en el frontend por ahora. Misma estructura que devuelve
// GET /api/menu, para poder reconectar con la base de datos después sin
// tocar las páginas que lo consumen.
const MENU = [
  {
    id: 1,
    nombre: 'Cocteles de Autor',
    orden: 1,
    items: [
      { id: 1, nombre: 'El Que Se Fue', descripcion: 'Mezcal, licor de damiana, jugo de toronja y un toque de sal de gusano. Duele rico.', precio: 145 },
      { id: 2, nombre: "Otra Ronda Pa'l Dolor", descripcion: "Tequila reposado, jarabe de tamarindo, chile piquín y limón. Pa' seguirle.", precio: 130 },
      { id: 3, nombre: 'Bloqueado y Sin Filtro', descripcion: 'Vodka, jugo de arándano, licor de flor de Jamaica y burbuja. Directo, como tus mensajes sin enviar.', precio: 135 },
      { id: 4, nombre: 'Su Nueva Vida (Sin Ti)', descripcion: 'Ron añejo, piña, coco y un chorrito de amargura líquida.', precio: 140 },
      { id: 5, nombre: 'Ya Bloqueé Hasta a Su Mamá', descripcion: 'Gin, jugo de pepino, albahaca y jarabe de agave. Fresco pa\' empezar de cero.', precio: 138 },
      { id: 6, nombre: 'Despecho a las Rocas', descripcion: 'Whisky, jarabe de piloncillo y bitters de naranja. Se sirve solo, como tú ahora.', precio: 150 }
    ]
  },
  {
    id: 2,
    nombre: 'Cervezas',
    orden: 2,
    items: [
      { id: 7, nombre: 'Cerveza Clara Nacional', descripcion: 'Bien fría, la de siempre.', precio: 55 },
      { id: 8, nombre: 'Cerveza Obscura Artesanal', descripcion: 'Tostada, con cuerpo, ideal para llorar bonito.', precio: 75 },
      { id: 9, nombre: 'Michelada Despecho', descripcion: 'Con sal, chile y toda la salsa que tu vida necesita ahorita.', precio: 85 },
      { id: 10, nombre: 'Cerveza IPA Local', descripcion: 'Amarga por fuera, amarga por dentro. Como el ex.', precio: 80 }
    ]
  },
  {
    id: 3,
    nombre: 'Mezcales y Destilados',
    orden: 3,
    items: [
      { id: 11, nombre: 'Mezcal Espadín (Copa)', descripcion: 'Ahumado y directo, para los que ya no andan con rodeos.', precio: 95 },
      { id: 12, nombre: 'Tequila Añejo (Copa)', descripcion: 'Suave pero con carácter, igual que tú después de superarlo.', precio: 110 },
      { id: 13, nombre: 'Sotol Artesanal (Copa)', descripcion: 'Del desierto, para los corazones más resecos.', precio: 100 },
      { id: 14, nombre: 'Shot de la Dignidad', descripcion: 'Mezcal con sal de gusano. Se toma rápido, como la decisión de bloquear.', precio: 60 }
    ]
  },
  {
    id: 4,
    nombre: "Sin Alcohol",
    orden: 4,
    items: [
      { id: 15, nombre: 'Agua de Jamaica del Perdón', descripcion: 'Fresca y sin rencores.', precio: 45 },
      { id: 16, nombre: 'Limonada Renace Sola', descripcion: 'Limón, menta y mucha actitud.', precio: 48 },
      { id: 17, nombre: 'Mocktail Nueva Yo', descripcion: 'Piña, coco y granadina. Cero alcohol, cero drama.', precio: 65 }
    ]
  },
  {
    id: 5,
    nombre: 'Botanas',
    orden: 5,
    items: [
      { id: 18, nombre: 'Botana del Olvido', descripcion: 'Papas a la francesa con queso y tocino.', precio: 95 },
      { id: 19, nombre: 'Alitas Quémalo Todo', descripcion: 'Alitas bañadas en salsa picante extrema.', precio: 135 },
      { id: 20, nombre: 'Nachos Corazón Roto', descripcion: 'Nachos con frijoles, queso, pico de gallo y jalapeño.', precio: 115 },
      { id: 21, nombre: 'Queso Fundido Ya No Te Quiero', descripcion: 'Con chorizo y tortillas calientitas.', precio: 105 }
    ]
  },
  {
    id: 6,
    nombre: 'Antojitos Fuertes',
    orden: 6,
    items: [
      { id: 22, nombre: 'Tacos de la Despedida', descripcion: 'Tres tacos al pastor con piña y salsa verde.', precio: 120 },
      { id: 23, nombre: "Molcajete Pa' Los Dos (Ya No)", descripcion: 'Molcajete individual con arrachera, queso y nopales.', precio: 195 },
      { id: 24, nombre: 'Quesadillas Sin Compromiso', descripcion: 'Quesadillas de flor de calabaza y huitlacoche.', precio: 110 },
      { id: 25, nombre: 'Torta Ahogada del Despecho', descripcion: 'Bañada en salsa picante, para ahogar penas, no torta.', precio: 105 }
    ]
  }
];

export default MENU;
